import Vue from 'vue'
import Axios from 'axios'
import VueCookies from 'vue-cookies'

import './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(VueCookies)
Vue.prototype.$http = Axios

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
